export const LANGUAGE_SELECT = 'LANGUAGE_SELECT';

export function languageSelect(didpatch, language) {
  return didpatch({
    type: LANGUAGE_SELECT,
    language,
  });
}
